import ToolsMenuView from './tools-menu-view'

export default ToolsMenuView
